/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import ic_person from "../../assets/images/pictures/icon/ic_person_24px.svg";
import ic_folder_open from "../../assets/images/pictures/icon/ic_folder-open_24px.svg";
import ic_euro from "../../assets/images/pictures/icon/ic_euro_yellow_24px.svg";
import ic_split from "../../assets/images/pictures/icon/ic_split_yellow_24px.svg";
import ic_check_circle from "../../assets/images/pictures/icon/ic_check-circle-yellow_24px.svg";
import ic_list from "../../assets/images/pictures/icon/ic_list_yellow_24px.svg";
import ic_layer from "../../assets/images/pictures/icon/ic_layers_64px.svg";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import routeVariants from "../../assets/animates/routeVariants";
import features_for_teams_2 from "../../assets/images/pictures/features-for-teams-content-2.png";
import Footer from "./../global/Footer";
import NavbarBottom from "./../global/NavbarBottom";

const FeatureForTeamsContent = () => {
  const { t, i18n } = useTranslation();

  return (
    <motion.div
      variants={routeVariants}
      initial="initial"
      animate="final"
      id="content"
      className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform"
    >
      <div className="container-fuild bg-color-home background-features-for-teams-image">
        <div className="container">
          <div className="row">
            <div className="col-md-8 px-md-0 pt-60 pt-md-116">
              <h2 className="font-weight-bold mx-auto text-white font-60">
                {t(
                  "features-for-teams-page.features-for-teams-content.content-1.heading"
                )}
              </h2>
              <p className="mb-25 mt-25 text-white max-width-lg-85-percent">
                {t(
                  "features-for-teams-page.features-for-teams-content.content-1.description"
                )}
              </p>
              <a
                href={`https://gopaperless.mobile-id.vn/workflow/portal/login?language=${
                  i18n.language || "vi"
                }`}
                target="_blank"
                rel="noopener noreferrer"
                id="button-start-free-en"
                className="btn-secondary"
              >
                {t(
                  "features-for-teams-page.features-for-teams-content.content-1.button-get-started"
                )}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="features-page">
        <div className="container-fluid bg-color-features">
          <div className="container features-page__container px-md-0 pt-50">
            <div className="row">
              <div className="col-md-6 col-sm-12">
                <img
                  width="64"
                  height="64"
                  src={ic_person}
                  className="attachment-full size-full"
                  alt=""
                  decoding="async"
                  loading="lazy"
                  data-no-retina=""
                />
                <h2 className="heading font-weight-bold">
                  {t(
                    "features-for-teams-page.features-for-teams-content.content-2.big-heading"
                  )}
                </h2>
                <p className="subheading">
                  {t(
                    "features-for-teams-page.features-for-teams-content.content-2.big-description"
                  )}
                </p>
                <div className="boxes boxes--vertical">
                  <div className="boxes__item p-0">
                    <h5 className="heading">
                      {t(
                        "features-for-teams-page.features-for-teams-content.content-2.small-heading-1"
                      )}
                    </h5>
                    <p>
                      {t(
                        "features-for-teams-page.features-for-teams-content.content-2.small-description-1"
                      )}
                    </p>
                  </div>
                  <div className="boxes__item p-0">
                    <h5 className="heading">
                      {t(
                        "features-for-teams-page.features-for-teams-content.content-2.small-heading-2"
                      )}
                    </h5>
                    <p>
                      {t(
                        "features-for-teams-page.features-for-teams-content.content-2.small-description-2"
                      )}
                    </p>
                  </div>
                  <div className="boxes__item p-0">
                    <h5 className="heading">
                      {t(
                        "features-for-teams-page.features-for-teams-content.content-2.small-heading-3"
                      )}
                    </h5>
                    <p>
                      {t(
                        "features-for-teams-page.features-for-teams-content.content-2.small-description-3"
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 mt-100">
                <img
                  width="666"
                  height="527"
                  src={require("../../assets/images/pictures/process-en.png")}
                  className="img-responsive"
                  alt="process"
                  decoding="async"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          <div className="container features-page__container px-md-0 pt-100 pb-50">
            <div className="row">
              <div className="col-md-6 col-sm-12">
                <img
                  width="64"
                  height="64"
                  src={ic_folder_open}
                  className="attachment-full size-full"
                  alt=""
                  decoding="async"
                  loading="lazy"
                  data-no-retina=""
                />
                <h2 className="heading font-weight-bold">
                  {t(
                    "features-for-teams-page.features-for-teams-content.content-3.big-heading"
                  )}
                </h2>
                <p className="subheading">
                  {t(
                    "features-for-teams-page.features-for-teams-content.content-3.big-description"
                  )}
                </p>
                <div className="boxes boxes--vertical">
                  <div className="boxes__item p-0">
                    <h5 className="heading">
                      {t(
                        "features-for-teams-page.features-for-teams-content.content-3.small-heading-1"
                      )}
                    </h5>
                    <p>
                      {t(
                        "features-for-teams-page.features-for-teams-content.content-3.small-description-1"
                      )}
                    </p>
                  </div>
                  <div className="boxes__item p-0">
                    <h5 className="heading">
                      {t(
                        "features-for-teams-page.features-for-teams-content.content-3.small-heading-2"
                      )}
                    </h5>
                    <p>
                      {t(
                        "features-for-teams-page.features-for-teams-content.content-3.small-description-2"
                      )}
                    </p>
                  </div>
                  <div className="boxes__item p-0">
                    <h5 className="heading">
                      {t(
                        "features-for-teams-page.features-for-teams-content.content-3.small-heading-3"
                      )}
                    </h5>
                    <p>
                      {t(
                        "features-for-teams-page.features-for-teams-content.content-3.small-description-3"
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-sm-12 mt-60">
                <img
                  width="628"
                  height="554"
                  src={require("../../assets/images/pictures/management-en.png")}
                  className="img-responsive"
                  alt=""
                  decoding="async"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="container-fuild bg-primary">
          <div className="container features-page__container px-md-0 pt-50 pb-50">
            <div className="row">
              <div className="col-md-10 col-md-offset-1 col-sm-12 text-center">
                <img
                  width="64"
                  height="64"
                  src={ic_check_circle}
                  className="img-responsive"
                  alt=""
                  decoding="async"
                  loading="lazy"
                  data-no-retina=""
                />
                <h2 className="heading font-weight-bold text-white">
                  {t(
                    "features-for-teams-page.features-for-teams-content.content-4.big-heading"
                  )}
                </h2>
                <h4 className="subheading text-white">
                  {t(
                    "features-for-teams-page.features-for-teams-content.content-4.big-description"
                  )}
                </h4>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 justify-md-center">
                <div className="text-center boxes boxes--one-row justify-evenly pb-16 block-xs">
                  <div className="features-for-teams-background-radius mb-10">
                    <div className="boxes__item p-0">
                      <div className="eclipse-background">
                        <div className="features-for-teams-inline-darkblue-circle">
                          <img
                            width="24"
                            height="24"
                            src={ic_list}
                            className="attachment-full size-full"
                            alt=""
                            decoding="async"
                            loading="lazy"
                            data-no-retina=""
                          />
                        </div>
                      </div>
                      <h5 className="heading">
                        {t(
                          "features-for-teams-page.features-for-teams-content.content-4.small-heading-1"
                        )}
                      </h5>
                      <p>
                        {t(
                          "features-for-teams-page.features-for-teams-content.content-4.small-description-1"
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="features-for-teams-background-radius mb-10">
                    <div className="boxes__item p-0">
                      <div className="eclipse-background">
                        <div className="features-for-teams-inline-darkblue-circle">
                          <img
                            width="24"
                            height="24"
                            src={ic_euro}
                            className="attachment-full size-full"
                            alt=""
                            decoding="async"
                            loading="lazy"
                            data-no-retina=""
                          />
                        </div>
                      </div>
                      <h5 className="heading">
                        {t(
                          "features-for-teams-page.features-for-teams-content.content-4.small-heading-2"
                        )}
                      </h5>
                      <p>
                        {t(
                          "features-for-teams-page.features-for-teams-content.content-4.small-description-2"
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="features-for-teams-background-radius mb-10">
                    <div className="boxes__item p-0">
                      <div className="eclipse-background">
                        <div className="features-for-teams-inline-darkblue-circle">
                          <img
                            width="24"
                            height="24"
                            src={ic_split}
                            className="attachment-full size-full"
                            alt=""
                            decoding="async"
                            loading="lazy"
                            data-no-retina=""
                          />
                        </div>
                      </div>
                      <h5 className="heading">
                        {t(
                          "features-for-teams-page.features-for-teams-content.content-4.small-heading-3"
                        )}
                      </h5>
                      <p>
                        {t(
                          "features-for-teams-page.features-for-teams-content.content-4.small-description-3"
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <img
                  width="1122"
                  height="392"
                  src={require("../../assets/images/pictures/company-en.png")}
                  className="img-responsive"
                  alt=""
                  decoding="async"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="container-fuild bg-color-B1D1F5">
          <div className="container features-page__container px-md-0 pt-50 pb-50 ">
            <div className="row">
              <div className="col-sm-10 col-sm-offset-1 text-center">
                <img
                  width="64"
                  height="64"
                  src={ic_layer}
                  className="img-responsive"
                  alt=""
                  decoding="async"
                  loading="lazy"
                  data-no-retina=""
                />
                <h2 className="heading font-weight-bold">
                  {t(
                    "features-for-teams-page.features-for-teams-content.content-5.big-heading"
                  )}
                </h2>
                <h4 className="subheading">
                  {t(
                    "features-for-teams-page.features-for-teams-content.content-5.big-description"
                  )}
                </h4>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <img
                  width="498"
                  height="566"
                  src={require("../../assets/images/pictures/features-for-teams-content-3.png")}
                  className="img-responsive"
                  alt=""
                  decoding="async"
                  loading="lazy"
                />
              </div>
              <div className="col-md-6">
                <div className="boxes">
                  <div className="boxes__item">
                    <h5 className="heading">
                      {t(
                        "features-for-teams-page.features-for-teams-content.content-5.small-heading-1"
                      )}
                    </h5>
                    <p>
                      {t(
                        "features-for-teams-page.features-for-teams-content.content-5.small-description-1"
                      )}
                    </p>
                  </div>
                  <div className="boxes__item">
                    <h5 className="heading">
                      {t(
                        "features-for-teams-page.features-for-teams-content.content-5.small-heading-2"
                      )}
                    </h5>
                    <p>
                      {t(
                        "features-for-teams-page.features-for-teams-content.content-5.small-description-2"
                      )}
                    </p>
                  </div>
                  <div className="boxes__item">
                    <h5 className="heading">
                      {t(
                        "features-for-teams-page.features-for-teams-content.content-5.small-heading-3"
                      )}
                    </h5>
                    <p>
                      {t(
                        "features-for-teams-page.features-for-teams-content.content-5.small-description-3"
                      )}
                    </p>
                  </div>
                  <div className="boxes__item">
                    <h5 className="heading">
                      {t(
                        "features-for-teams-page.features-for-teams-content.content-5.small-heading-4"
                      )}
                    </h5>
                    <p>
                      {t(
                        "features-for-teams-page.features-for-teams-content.content-5.small-description-4"
                      )}
                    </p>
                  </div>
                  <div className="boxes__item">
                    <h5 className="heading">
                      {t(
                        "features-for-teams-page.features-for-teams-content.content-5.small-heading-5"
                      )}
                    </h5>
                    <p>
                      {t(
                        "features-for-teams-page.features-for-teams-content.content-5.small-description-5"
                      )}
                    </p>
                  </div>
                  <div className="boxes__item">
                    <h5 className="heading">
                      {t(
                        "features-for-teams-page.features-for-teams-content.content-5.small-heading-6"
                      )}
                    </h5>
                    <p>
                      {t(
                        "features-for-teams-page.features-for-teams-content.content-5.small-description-6"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid container-fluid--background pt-16 pb-16">
          <div className="container features-page__container features-page__container--footer px-md-0">
            <div className="row">
              <div className="col-sm-6 pt-16">
                <h2 className="heading mx-auto font-weight-bold">
                  {t(
                    "features-for-teams-page.features-for-teams-content.content-6.heading"
                  )}
                </h2>
                <p className="subheading mt-25 mb-25">
                  {t(
                    "features-for-teams-page.features-for-teams-content.content-6.description"
                  )}
                </p>{" "}
                <a href="/solutions" className="btn-primary">
                  {t(
                    "features-for-teams-page.features-for-teams-content.content-6.button-take-a-look"
                  )}
                </a>
              </div>
              <div className="col-sm-6">
                <img
                  width="528px"
                  src={features_for_teams_2}
                  className="img-responsive"
                  alt="dogo"
                  decoding="async"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <NavbarBottom />
    </motion.div>
  );
};

export default FeatureForTeamsContent;
